import { WalletAddressType } from "@lib/types/Billing";

export const coinRegexPatterns: Record<WalletAddressType, RegExp | RegExp[]> = {
  BTC: [
    /^[13][a-km-zA-HJ-NP-Z1-9]{25,34}$/m,
    /^bc1[ac-hj-np-zAC-HJ-NP-Z02-9]{11,71}$/m,
    /^(bc1|[13])[a-zA-HJ-NP-Z0-9]{25,39}$/m,
  ],
  ETH: [/^(0x)?[0-9a-fA-F]{40}$/m, /^0x[a-fA-F0-9]{40}$/m],
  USDT: [/^T[A-Za-z1-9]{33}$/m, /^0x[a-fA-F0-9]{40}$/m],
};
